// WARNING: Order of imports is important!
import 'jquery';
import angular from 'angular';

import moment from 'moment';
import 'bootstrap-daterangepicker';
import 'angular-daterangepicker';

import {Component, Module} from 'app/decorators';
import {fromDR, toDR} from 'app/utils';


function isMomentEqual(date1, date2) {
    if (moment.isMoment(date1) && moment.isMoment(date2)) {
        return date1.isSame(date2, 'day');
    } else {
        return date1 === date2;
    }
}


@Module({
    name: "app.directives.daterangepicker",
    modules: [
        'daterangepicker',
    ],
})
@Component({
    selector: 'blnd-date-range-picker',
    bindings: {
        ngModel: '=',
        ngChange: '&?',
        format: '@?',
    },
    template: `<input
            placeholder="No Dates Selected"
            class="form-control date-picker"
            type="text"
            ng-change="$ctrl.onChange"
            date-range-picker options="$ctrl.options" ng-model="$ctrl.date"/>`,
    link: function(scope, element, attrs) {
        scope.$on('$destroy', function () {
            element.remove();
        })
    }
})
export default class D {
    constructor ($scope, $timeout) {
        "ngInject";
        let self = this;
        self.$timeout = $timeout;
        self.format = self.format || 'object';  // can be 'string'

        self.options = {
            opens: "left",
            ranges: {
                'This Week': [moment().startOf('week'), moment().endOf('week')],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'This Year': [moment().startOf('year'), moment().endOf('year')],
            },
            locale: {
                format: 'MM/DD/YYYY',
            },
        };
        let watcher = $scope.$watch('$ctrl.date', function(newV, oldV){
            oldV = oldV || {startDate: null, endDate: null};
            newV = newV || {startDate: null, endDate: null};
            if (!(isMomentEqual(newV.startDate, oldV.startDate) && isMomentEqual(newV.endDate, oldV.endDate))) {
                let newNgModel = self.fromPickerFormat(newV);

                if (self.ngModel != newNgModel) {
                    self.ngModel = self.fromPickerFormat(newV);
                    self.$timeout(function(){
                        self.ngChange && self.ngChange(newV, oldV);
                    });
                }
            }
        });

        $scope.$watch('$ctrl.ngModel', function(newV, oldV){
            self.date = self.toPickerFormat(newV);
        });

        $scope.$on('$destroy', function () {
            watcher();
            watcher = null;
        });
    }

    fromPickerFormat (dates){
        if (!dates || !dates.startDate || !dates.endDate) {
            return '';
        }
        if (this.format === 'string') {
            dates = toDR(dates);
        }
        return dates;
    }

    toPickerFormat (dates) {
        if (!dates) {
            return {
                startDate: null,
                endDate: null,
            }
        }

        if (this.format === 'string') {
            dates = fromDR(dates);
        }

        return dates
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/blnd.daterangepicker.js